"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PaymentMethod;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _styles = require("@sart/styles");
var _icons = require("@sart/icons");
var _content = require("@sart/content");
var _client = require("@sart/client");
var _Text = _interopRequireDefault(require("./Text"));
var _Label = _interopRequireDefault(require("./Label"));
var _Space = _interopRequireDefault(require("./Space"));
var _Anchor = _interopRequireDefault(require("./Anchor"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function PaymentMethod(props) {
  var content = (0, _content.useContent)();
  var editable = props.editable,
    disabled = props.disabled,
    onEditPayment = props.onEditPayment,
    title = props.title,
    style = props.style,
    footerStyle = props.footerStyle;
  var payment = props.payment;
  if (payment === undefined) {
    payment = {
      preview: content.storedPayment.selectPayment
    };
  }
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.container
  }, title && /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: style
  }, title), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    style: styles.wrapper,
    disabled: disabled || !editable,
    onPress: onEditPayment
  }, /*#__PURE__*/_react["default"].createElement(_icons.CreditCartType, {
    type: payment.type
  }), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 12,
    height: 24
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [style, disabled && styles.previewDisabled]
  }, payment.preview)), editable && /*#__PURE__*/_react["default"].createElement(_Anchor["default"], (0, _extends2["default"])({
    style: footerStyle,
    title: payment && payment.type ? content.common.change : content.common.choose,
    onPress: onEditPayment,
    disabled: disabled
  }, style && style.storedPaymentChoose && {
    style: style.storedPaymentChoose
  })));
}
var styles = _reactNative.StyleSheet.create({
  container: {
    // paddingVertical: 8
  },
  wrapper: _objectSpread(_objectSpread({
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12
  }, _reactNative.Platform.select({
    web: {
      padding: 8
    }
  })), {}, {
    borderRadius: _styles.radius.smedium,
    backgroundColor: _styles.backgroundColors.subtle
  }),
  preview: _objectSpread({
    fontSize: 18
  }, _reactNative.Platform.select({
    web: {
      fontSize: 15
    }
  })),
  previewDisabled: {
    color: _styles.colors.trivial
  },
  choose: {
    fontSize: 15,
    color: _styles.colors.trivial,
    marginTop: 8
  }
});